
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bundesliga/players",
      function () {
        return require("private-next-pages/bundesliga/players/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bundesliga/players"])
      });
    }
  